import { useEffect } from 'react';
import { BroadcastChannel } from 'broadcast-channel';

export const collectorBroadcast = new BroadcastChannel('collector', {
  webWorkerSupport: false
});

export const useCollectorBroadcast = ({
  onBroadcast
}: {
  onBroadcast: (collectorId: string) => void;
}): void => {
  useEffect(() => {
    collectorBroadcast.addEventListener('message', onBroadcast);
    return () => {
      collectorBroadcast.removeEventListener('message', onBroadcast);
    };
  }, [onBroadcast]);
};
